import { Component, OnInit } from '@angular/core';
import {PRIVILEDGES} from '../modules/service/roles.mockup';
import {Router} from '@angular/router';
import {DashboardService} from '../modules/service/dashboard.service';
import { MatDialog } from '@angular/material';
import { ResetPasswordComponent } from '../dialogs/reset-password/reset-password.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

usr={
  email:'',
  password:'',
  role:'admin'
}

em:any;
  pwd:any;

  constructor( private router:Router, private service: DashboardService, private dialog: MatDialog) { }

  ngOnInit() {
  }

  login(){
    Swal.showLoading();

    

  var test = JSON.stringify(this.usr)
  
    this.service.getLogin(test)
    .toPromise()
    .then((data: any)=>{

      if(data['responseCode'] == '000'){
        data['profile'][0]['account_activation_requested']=data['account_activation_requested'];
        data['profile'][0]['reset_requested']=data['reset_requested'];

        localStorage.setItem('isLoggedInStatus', JSON.stringify(data['profile'][0]));
        localStorage.setItem('userdata',JSON.stringify(data['profile'][0]));

        if(data['profile'][0]['role']==="manager"){
          this.router.navigate(['dashboard']);

       }else{
        this.router.navigate(['dashboard']);

       }
       Swal.close();
     }
     else if(data['responseCode']==='W1012'){
              //  alert("Invalid Credential");
             //Swal.showLoading();
            (Swal as any).fire({
            title: 'Warning!',
            text: 'Please enter your credentials',
            icon: 'warning',
          });


       }else if(data['responseCode']==='W1013'){
         //alert("Wrong UserEmail Or Password ");
         //Swal.showLoading();
         (Swal as any).fire({
        title: 'Oops...',
        text: 'Wrong UserEmail Or Password !',
        icon: 'error'
         });

       }
    })
    .catch(()=>{
      (Swal as any).fire({
        title: 'Oops...',
        text: 'Login Error!',
        icon: 'error'
         });
    })

  }
  forgotpassword(){
    //this.router.navigate(['/reset_manager_password'])
    const dialogRef = this.dialog.open(ResetPasswordComponent, {
      disableClose :true,
      width: '500px',
      data: {  }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

}
